import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortDate' //this is used in html templates
})
export class SortDatePipe implements PipeTransform {

  transform(array: any): Array<any> {
        this.sortEventDate(array);
        return array; 
  }
  
  sortEventDate(array) {
    array.sort( function(item1, item2) {
	    if ( item1.custom_fields.event_start_date < item2.custom_fields.event_start_date ){
	    	return -1;
	    }else if( item1.custom_fields.event_start_date > item2.custom_fields.event_start_date ){
	        return 1;
	    }else{
	    	return 0;	
	    }
	});   
  }

}
